import styled from 'styled-components/macro'
import { Typography, Grid, Select, TextField } from '@mui/material'

export const StyledGridContainer = styled(Grid)`
  background-color: ${(props) => props.theme.tokens.tertiary};
  padding: 15px;
`
export const StyledSelect = styled(Select)`
  && {
    background-color: ${(props) => props.theme.tokens.surfaceBright};
    width: 100%;
  }
`

export const StyledLabel = styled(Typography)`
  && {
    color: ${(props) => props.theme.tokens.secondary};
    font-weight: bold;
    padding: 10px 5px;
  }
`

export const StyledText = styled(Typography)`
  && {
    color: ${(props) => props.theme.tokens.primary};
    width: 100%;
    text-align: center;
  }
`

export const StyledTextField = styled(TextField)`
  && {
    border-radius: 40px;
    background-color: ${(props) => props.theme.tokens.surfaceBright};
    height: 48px;
    position: relative;
    margin-left: 0;
    width: 80%;
    .MuiInputBase-root {
      height: 48px;
      align-items: center;
    }
    input::placeholder {
      color: ${(props) => props.theme.tokens.secondary};
      font-weight: bold;
      opacity: 1;
    }
    input {
      color: ${(props) => props.theme.tokens.secondary};
      padding: 0 0 0 24px;
      line-height: 1.2;
    }
    .MuiInputAdornment-root {
      margin-right: 24px;
    }
    @media (max-width: 959px) {
      width: 100%;
    }
  }
`
export const StyledSelectContainer = styled.div`
  display: relative;
  align-items: center;
  margin-right: 12px;
`
